export default function AutodeskWelcomeLogoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="17"
      viewBox="0 0 29 17"
      fill="none"
    >
      <path
        d="M5.10199 15L16.7392 7.75931H22.7762C22.9625 7.75931 23.1287 7.90787 23.1287 8.11193C23.1287 8.27826 23.0556 8.35364 22.9625 8.40905L17.2447 11.8354C16.8723 12.0594 16.7436 12.5052 16.7436 12.8378L16.737 14.9978H24V2.44575C24 2.20403 23.8138 2 23.5366 2H16.6084L5 9.20744V14.9978H5.10199V15Z"
        fill="black"
      />
    </svg>
  );
}
